import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import MoldeModel from "@/models/moldeModel";
import moldeService from "@/services/moldeService";

import ListComponentBase from "../listComponentBase";

@Component
export default class MoldeListComponent extends ListComponentBase<MoldeModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", "Descrição", GridColumnType.String),
            new GridColumn("volumeInterno", "Volume", GridColumnType.Decimal),
            new GridColumn("ativo", "Ativo", GridColumnType.Boolean),
        ];
    }

    private beforeMount() {
        this.setPropsCached(moldeService, "molde", "descricao");
    }
}
